/**
 * Store admin — content pages list + inline editor (module 22).
 */
import { createFileRoute } from "@tanstack/react-router";
import { PagesListPage } from "../../../../../features/store/pages/pages-list-page.tsx";

export const Route = createFileRoute("/(workspace)/store/admin/pages/")({
  component: PagesListPage,
});
